import React, {PropTypes} from 'react';
import ClubRow from './ClubRow';

const ClubList = ({clubList, loading}) => {
  // const savingsExist = NumberFormatter.scrubFormatting(savings.monthly) > 0;
  // const savingsClass = savingsExist ? 'savings' : 'loss';
  // const resultLabel = savingsExist ? 'Savings' : 'Loss';

  return (
    <div className="club-list-wrapper">
      <table className="table table-responsive  table-bordered table-background">
        <thead>
          <tr>
            <th>Navn</th>
            <th>Medlemmer</th>
          </tr>
        </thead>
        <tbody>
          {clubList.map((club, index) => {
            return (
              <ClubRow key={index}
                club={club}
                loading={loading}
                 />
            );
          })}
        </tbody>
      </table>

    </div>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
ClubList.propTypes = {
  clubList: PropTypes.array.isRequired,
  loading: PropTypes.bool
};

export default ClubList;



/** WEBPACK FOOTER **
 ** ./src/components/club/ClubList.js
 **/